import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SupportService from "../../services/SupportService";

const POLL_MS = 60000;

/*
 * Bell of the support: number of tickets with something new for the connected side
 * (new tickets for the super admin, new answers for a client), refreshed every minute.
 */
const SupportBell = () => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      SupportService.unreadCount()
        .then((response) => {
          const value = response.data && response.data.success;
          if (!cancelled && typeof value === "number") setCount(value);
        })
        .catch(() => {});
    };
    refresh();
    const timer = setInterval(refresh, POLL_MS);
    return () => {
      cancelled = true;
      clearInterval(timer);
    };
  }, []);

  return (
    <li className="nav-item">
      <Link
        className="nav-link"
        to="/support"
        title={count > 0 ? `${count} ticket(s) de support avec du nouveau` : "Support"}
      >
        <i className="far fa-life-ring" />
        {count > 0 && <span className="badge badge-danger navbar-badge">{count}</span>}
      </Link>
    </li>
  );
};

export default SupportBell;
